import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Paper,
  Typography,
  Tabs,
  Tab,
  Breadcrumbs
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PublicIcon from '@mui/icons-material/Public';
import CategoryIcon from '@mui/icons-material/Category';
import DescriptionIcon from '@mui/icons-material/Description';
import RuleIcon from '@mui/icons-material/Rule';
import { updateScreenTitle } from '../../../LayoutContainers/AppLayout/redux/AppSlice';
import VerticalsPage from './Verticals/VerticalsPage';
import CategoriesPage from './Categories/CategoriesPage';
import DocumentTypesPage from './DocumentTypes/DocumentTypesPage';
import RequiredRulesPage from './RequiredRules/RequiredRulesPage';

// TabPanel component
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`doc-config-tabpanel-${index}`}
      aria-labelledby={`doc-config-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

/**
 * Organization Document Configuration Main Screen
 * Admin screen for configuring document types, categories, verticals, and rules
 * UI-First approach with mock data
 */
const DocConfigMain = () => {
  const [activeTab, setActiveTab] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateScreenTitle("Document Configuration"));
    return () => dispatch(updateScreenTitle(""));
  }, [dispatch]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth="xl">
      {/* Header with breadcrumbs */}
      <Box sx={{ mb: 3 }}>
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
          <Link to="/admin" style={{ textDecoration: 'none', color: 'inherit' }}>
            Admin
          </Link>
          <Typography color="text.primary">Document Configuration</Typography>
        </Breadcrumbs>

        <Typography variant="h4" component="h1">
          Organization Document Configuration
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Configure document types, categories, verticals, and required document rules
        </Typography>
      </Box>

      {/* Tabbed interface */}
      <Paper elevation={2} sx={{ mb: 4 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="document configuration tabs"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab
            icon={<PublicIcon />}
            label="Verticals"
            iconPosition="start"
            sx={{ minHeight: 64 }}
          />
          <Tab
            icon={<CategoryIcon />}
            label="Categories"
            iconPosition="start"
            sx={{ minHeight: 64 }}
          />
          <Tab
            icon={<DescriptionIcon />}
            label="Document Types"
            iconPosition="start"
            sx={{ minHeight: 64 }}
          />
          <Tab
            icon={<RuleIcon />}
            label="Required Rules"
            iconPosition="start"
            sx={{ minHeight: 64 }}
          />
        </Tabs>

        {/* Verticals Tab */}
        <TabPanel value={activeTab} index={0}>
          <VerticalsPage />
        </TabPanel>

        {/* Categories Tab */}
        <TabPanel value={activeTab} index={1}>
          <CategoriesPage />
        </TabPanel>

        {/* Document Types Tab */}
        <TabPanel value={activeTab} index={2}>
          <DocumentTypesPage />
        </TabPanel>

        {/* Required Rules Tab */}
        <TabPanel value={activeTab} index={3}>
          <RequiredRulesPage />
        </TabPanel>
      </Paper>
    </Container>
  );
};

export default DocConfigMain;
